export default "__VITE_ASSET__w0H3QgvU__"